module.exports = __webpack_public_path__ + "media/venue/meetups@3x-cd7853fb.png";